export default "__VITE_ASSET__Du08qO3L__"